import { compact } from 'lodash';

import { abbrToKeyMap, stratificationsConfig, StratKey } from './startifications.config';

export function abbrToKeys(abbrStr: string) {
  const abbr = abbrStr.split(',');
  const keys = abbr.map((abbr) => {
    const key = abbrToKeyMap[abbr];
    if (!key) {
      return null;
    }
    return key;
  });

  return compact(keys);
}

export function keysToAbbr(keys: StratKey[]) {
  const abbrs = keys.map((key) => {
    const config = stratificationsConfig[key as StratKey];
    return config?.abbr;
  });

  return compact(abbrs).join(',');
}
